import { defineStore } from 'pinia'

export const useUserStore = defineStore('userStore', () => {
  const user = ref(null)
  const isInitialized = ref(false)
  const acceptedCookies = ref(false)
  const token = ref(null)

  const isAuthenticated = computed(() => Boolean(user.value))
  const isAdmin = computed(() => user.value?.isAdmin ?? false)
  const isSubscriber = computed(() => user.value?.isSubscriber ?? false)

  /**
   * @param {momentshare.models.user.User|null} newUser
   * @returns {void}
   */
  function setUser(newUser) {
    user.value = newUser
  }

  function setIsInitialized(value) {
    isInitialized.value = value
  }

  function logout() {
    setUser(null)
    setToken(null)
  }

  function setAcceptedCookies() {
    acceptedCookies.value = true
  }

  /**
   * @param {Object} newToken
   * @returns {void}
   */
  function setToken(newToken) {
    token.value = newToken
  }

  return {
    user,
    isInitialized,
    acceptedCookies,
    token,
    isAuthenticated,
    isAdmin,
    isSubscriber,
    setUser,
    setIsInitialized,
    logout,
    setAcceptedCookies,
    setToken,
  }
})
